export default "__VITE_ASSET__D7CHdCc4__"